function init() {
 
    const productForms = document.querySelectorAll('[action^="/cart/add"]');

    productForms.forEach(form => {
      const sellingPlanContainer = document.createElement("input");
      sellingPlanContainer.id = "selling_plan";
      sellingPlanContainer.className = "gsa_selling_plan";
      sellingPlanContainer.type = "hidden";
      sellingPlanContainer.setAttribute("name", "selling_plan");
      sellingPlanContainer.value = "";
   
      form.appendChild(sellingPlanContainer.cloneNode());
    });

    const currencyToLocaleMap = {
      'USD': 'en-US',
      'EUR': 'fr-FR',
      'GBP': 'en-GB',
      'CAD': 'en-CA',
      'AUD': 'en-AU',
      'JPY': 'ja-JP',
      'CNY': 'zh-CN',
      'HKD': 'zh-HK',
      'NZD': 'en-NZ',
      'CHF': 'de-CH',
      'ZAR': 'en-ZA',
      'SEK': 'sv-SE',
      'NOK': 'nb-NO',
      'DKK': 'da-DK',
      'INR': 'en-IN',
      'SGD': 'en-SG',
      'MXN': 'es-MX',
      'BRL': 'pt-BR',
      'RUB': 'ru-RU',
      'PLN': 'pl-PL',
      'PHP': 'en-PH',
      'TRY': 'tr-TR',
      'THB': 'th-TH',
      'MYR': 'ms-MY',
      'IDR': 'id-ID',
      'TWD': 'zh-TW',
      'VND': 'vi-VN',
      'KRW': 'ko-KR',
      'AED': 'ar-AE'
  };

    const locale = currencyToLocaleMap[currency] || 'en-US';

    const formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
    });

    let lastSubscriptionPosition = 0;
 
    const mapSellingPlan = (currentVariantId, subscriptionPosition) => {
        const onetimePrice = document.getElementById("one-time-price");
        const productData = productJSON;
        const productVariants = productData.variants;
        //console.log(productData);
        const onetimeFilterPrice = productVariants.find(p => p.id === parseInt(currentVariantId));
        //console.log(onetimeFilterPrice);
        let setOnetimePrice = formatter.format((onetimeFilterPrice.price / 100).toFixed(2));
        onetimePrice.innerHTML = setOnetimePrice;
 
        if (subscriptionPosition === null) {
            lastSubscriptionPosition = lastSubscriptionPosition;
            updateSubscriptionPrice(productData, lastSubscriptionPosition);
        } else {
            lastSubscriptionPosition = subscriptionPosition;
            updateSubscriptionPrice(productData, lastSubscriptionPosition);
        }
    }
 
    const updateSubscriptionPrice = (productData, lastSubscriptionPosition) => {
        const subscriptionPrice = document.getElementById("subscription-price");
        let currentSellingPlanId = productData.selling_plan_groups[0].selling_plans[lastSubscriptionPosition].id;
        // console.log(currentSellingPlanId);
        const subscriptionFilterVariants = productData.variants.find(p => p.id === parseInt(currentVariantId)).selling_plan_allocations;
        const subscriptionFilterPrice = subscriptionFilterVariants.find(p => p.selling_plan_id === parseInt(currentSellingPlanId));
        // console.log(subscriptionFilterPrice);
        let setSubscriptionPrice = formatter.format((subscriptionFilterPrice.price / 100).toFixed(2));
        subscriptionPrice.innerHTML = setSubscriptionPrice;
    }
 
    class SellingPlan extends HTMLElement {
        constructor() {
            super();
            this.addEventListener("change", this.onSellingPlanChange);
            window.addEventListener("load", this.initialLoad);
        }
 
        initialLoad() {
            const variantElement = document.querySelector("selling-plan-selector");        
            const boundHandlePageLoad = handlePageLoad.bind(variantElement);
            boundHandlePageLoad();
            function handlePageLoad() {
                this.onSellingPlanChange();
            }
        }
 
        onSellingPlanChange() {
            this.updateSellingPlan();
            this.updateSellingPlanID();
            this.updatePurchaseOptionUI();
        }
 
        getSubscriptionJSON() {
            this.subscriptionData = this.subscriptionData || productJSON;
            return this.subscriptionData;
        }
 
        updateSellingPlan() {
            let variantSelector = document.querySelector('[name="id"]');
            let selectedVariantId = variantSelector.value;
 
            this.getSubscriptionJSON();
 
            const fieldsets = Array.from(this.querySelectorAll('#subscription-frequency-fieldset'));
            this.subscriptionFrequency = fieldsets.map((fieldset) => {
                return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
            });
            let currentSellingGroup = this.subscriptionData.selling_plan_groups[0].selling_plans;
 
            const names = [];
            for (let i = 0; i < currentSellingGroup.length; i++) {
                names.push(currentSellingGroup[i].name);
            }
 
            // console.log(this.subscriptionFrequency);
            // console.log(names);
 
           
            this.subscriptionPosition = names.indexOf(this.subscriptionFrequency[0]);
            this.currentSellingPlanID = this.subscriptionData.selling_plan_groups[0].selling_plans[this.subscriptionPosition].id;
        }
 
        updateSellingPlanID() {
            const subscriptionSelected = document.getElementById("subscription-option").checked;
            const sellingPlanContainers = document.querySelectorAll("#selling_plan");
           
            sellingPlanContainers.forEach(container => {
              if (subscriptionSelected) {
                container.value = this.currentSellingPlanID;
              } else {
                container.value = "";
              }
            });
            this.updateMappingLogic();
        }
 
        updateMappingLogic() {
            let subscriptionPosition = this.subscriptionPosition;
            const boundHandlePageLoadTest = handlePageLoadTest.bind(window);
            boundHandlePageLoadTest();
            function handlePageLoadTest() {
                mapSellingPlan(currentVariantId, subscriptionPosition);
            }
        }
 
        updatePurchaseOptionUI() {
            // console.log("Getting selected purchase option!");
            const subscriptionFequency = document.getElementById("subscription-frequency-fieldset");
            const subscriptionSelected = document.getElementById("subscription-option").checked;

            const accordionContent = document.getElementsByClassName("gsa-accordion-content")[0];

            const firstObjectionBuster = document.getElementById("gsa-first-objection-buster");
            const secondObjectionBuster = document.getElementById("gsa-second-objection-buster");

            const inputElements = document.querySelectorAll('input[name="purchase_options"]');
            const elementIds = [];

            inputElements.forEach(function(element) {
              elementIds.push(element.id);
              // console.log(`Position of input element ${element.id}: ${elementIds.indexOf(element.id)}`);
            });
            // console.log(elementIds);
           
            if (subscriptionSelected === true) {
                this.subscriptionIsSelected = true;
                subscriptionFequency.style.display = "block";
                accordionContent.classList.add('open');
                if (firstObjectionBuster) {
                  firstObjectionBuster.style.display = "block";
                  secondObjectionBuster.style.display = "none";
                }
            } else {
                this.subscriptionIsSelected = false;
                subscriptionFequency.style.display = "none";
                accordionContent.classList.remove('open');
                if (firstObjectionBuster) {
                  firstObjectionBuster.style.display = "none";
                  secondObjectionBuster.style.display = "block";
                }
            }
 
        }
 
 
        updateFrequencyUI() {
            let tabIndicator = document.getElementsByClassName('frequency_tab-indicator')[0];
            let frequencyOptions = document.querySelectorAll('.frequency_purchase_options .frequency_purchase_options_label');
            let tabHeader = document.getElementsByClassName('frequency_purchase_options')[0];
            tabIndicator.style.width = `calc(100% / ${frequencyOptions.length})`;
            let frequencyInputs = document.getElementsByName('Deliver every');
            for(let x = 0; x < frequencyInputs.length; x++) {
                if(frequencyInputs[x].checked) {
                    // console.log(frequencyInputs[x]);
                    tabIndicator.style.left = `calc(calc(100% / ${frequencyOptions.length}) * ${x})`;
                }
            }
 
        }
 
 
    }
 
    customElements.define("selling-plan-selector", SellingPlan);

        let variantSelector = document.querySelector('[name="id"]');
        let currentVariantId = variantSelector.value;

        variantSelector.addEventListener('change', function() {
          // Get the new variant ID
          let newVariantId = variantSelector.value;
          let subscriptionPosition = null;
          // Check if the variant has changed
          if (newVariantId !== currentVariantId) {
              currentVariantId = newVariantId;
              mapSellingPlan(currentVariantId, subscriptionPosition);
          }
      });
    }

    if (document.readyState === "loading") {
       document.addEventListener("DOMContentLoaded", init);
    } else {
      init();
    }